<template>
  <v-menu v-model="mostrar" :close-on-content-click="false" offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on">
        <v-icon>mdi-filter</v-icon>
      </v-btn>
    </template>
    <v-card
      width="450px">
      <v-card-title>Filtros</v-card-title>
      <v-card-text>
        <v-row no-gutters>
          <custom-select
            v-model="filtros.tipos"
            label="Tipo"
            item-value="id"
            item-text="descripcion"
            multiple
            clearable
            chips
            small-chips
            deletable-chips
            :items="tiposDeObra">
          </custom-select>
          <v-col
            cols="12"
            class="my-1">
            <v-divider></v-divider>
          </v-col>
          <custom-select
            v-model="filtros.financiamiento"
            label="Financiamiento"
            :items="financiamiento">
          </custom-select>
          <v-col
            cols="12"
            class="my-1">
            <v-divider></v-divider>
          </v-col>
          <custom-select
            v-model="filtros.programas"
            label="Programa"
            item-value="id"
            item-text="nombre"
            multiple
            clearable
            chips
            small-chips
            deletable-chips
            :items="programasDeObra">
          </custom-select>
          <custom-auto-complete
            v-model="filtros.contratistas"
            label="Contratista"
            multiple
            class="my-1"
            :items="contratistas"
            item-text="nombreRazonSocial"
            item-value="id"
            clearable
            chips
            small-chips
            deletable-chips>
          </custom-auto-complete>
          <custom-auto-complete
            v-model="filtros.supervisores"
            label="Supervisor"
            multiple
            :items="supervisores"
            item-text="nombre"
            item-value="id"
            clearable
            chips
            small-chips
            deletable-chips>
          </custom-auto-complete>
        </v-row>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import CustomAutoComplete from '@/components/inputs/Autocomplete.vue';
import CustomSelect from '@/components/inputs/Select.vue';

export default {
  name: 'FiltrosEjecucion',
  components: {
    CustomAutoComplete,
    CustomSelect,
  },
  props: {
    contratos: {
      type: Array,
      required: false,
    },
    filtros: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      mostrar: false,
      financiamiento: ['Todos', 'Normal', 'Financiado'],
    };
  },
  computed: {
    contratistas() {
      const contratistas = this.contratos.map((contrato) => contrato.contratista);
      if (contratistas.length <= 0) return [];
      return this.$removerDumplicadosArrayObj(contratistas, 'id')
        .sort((a, b) => (`${a.nombreRazonSocial}`).localeCompare(b.nombreRazonSocial));
    },
    supervisores() {
      const supervisores = this.contratos
        .filter(({ responsables }) => responsables.length > 0)
        .map(({ responsables }) => responsables)
        .flat()
        .filter(({ principal }) => principal === true)
        .map(({ funcionario }) => funcionario);

      if (supervisores.length <= 0) return [];

      return this.$removerDumplicadosArrayObj(supervisores, 'id')
        .sort((a, b) => (`${a.nombre}`).localeCompare(b.nombre));
    },
    tiposDeObra() {
      const tiposDeObraFiltrados = this.contratos
        .filter((contrato) => contrato.obra !== null)
        .map(({ obra }) => obra.obra.tipo);

      return this.$removerDumplicadosArrayObj(tiposDeObraFiltrados, 'id')
        .sort((a, b) => (`${a.descripcion}`).localeCompare(b.descripcion));
    },
    programasDeObra() {
      const programasDeObra = this.contratos
        .filter((contrato) => contrato.obra !== null)
        .map(({ obra }) => obra.obra.programa);

      return this.$removerDumplicadosArrayObj(programasDeObra, 'id')
        .sort((a, b) => (`${a.nombre}`).localeCompare(b.nombre));
    },
  },
};
</script>

<style lang="scss">
</style>
